import React from "react";
import InfoIcon from "@mui/icons-material/Info";

import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";
import CrossIcon from "../../../assets/Icons/cross_svg.svg";

const DuplicateModal = ({
  show,
  data,
  onSkip,
  onOverride,
  onClose,
}) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1031,
      }}
    >
      <div className="bg-white w-[600px] rounded-[20px] p-6 shadow-lg relative border border-gray-200">

        {/* Background Design */}
        <img
          src={LeftCircle}
          alt="left"
          className="absolute left-0 bottom-0 w-[90px] h-[90px] z-0"
        />
        <img
          src={RightCircle}
          alt="right"
          className="absolute right-0 top-0 w-[90px] h-[90px] z-0"
        />

        {/* Header */}
        <div className="flex justify-between items-center mb-3 relative z-10 pb-3 border-b border-gray-200">
          <div className="flex items-center gap-2">
            <InfoIcon className="text-[#FF6600]" />
            <h2 className="text-lg font-semibold text-[#FF6600]">
              Duplicate Records Found
            </h2>
          </div>

          <img
            src={CrossIcon}
            alt="close"
            onClick={onClose}
            className="w-5 h-5 cursor-pointer hover:rotate-90 transition-transform"
          />
        </div>

        {/* Content */}
        <div className="relative z-10 text-center">
          <p className="text-gray-700 text-sm mb-2">
            {`Total Duplicates: ${data?.duplicateCount || 0}`}
          </p>

          {/* Duplicate List */}
          <div className="max-h-[150px] overflow-y-auto border rounded-md p-3 bg-gray-50 text-left text-sm">
            {data?.duplicates?.length ? (
              data.duplicates.map((item, i) => (
                <p key={i} className="text-gray-600">
                  • {item}
                </p>
              ))
            ) : (
              <p className="text-gray-400 text-center">No duplicates</p>
            )}
          </div>

          {/* Message */}
          <p className="text-gray-600 text-sm mt-4">
            How would you like to proceed?
          </p>

          {/* Buttons */}
          <div className="flex justify-center gap-4 mt-6">
            <button
              onClick={onSkip}
              className="btn btn-back !rounded-[8px] w-[133px]"
            >
              Skip
            </button>

            <button
              onClick={onOverride}
              className="btn btn-submit !rounded-[8px] w-[133px]"
            >
              Override
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DuplicateModal;